var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRemoveFolder = function SvgRemoveFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C3.44772 4 3 4.44772 3 5V9V10V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V9C21 8.44772 20.5523 8 20 8H12.5L8.79289 4.29289C8.60536 4.10536 8.351 4 8.08579 4H4ZM11 5H20V7H13L11 5ZM15.9998 13.25H7.99977V14.75H15.9998V13.25Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRemoveFolder);
export default ForwardRef;